module.exports = __webpack_public_path__ + "img/500.f00f1ce3.svg";